import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import CloseSvg from "../../assets/taiga-uikit/icons/close.svg?react";
import MagicpenSvg from "../../assets/taiga-uikit/icons/magic-ai.svg?react";
import {
  _colorText,
  _size,
  _sizeText,
  _style,
  _typeInput,
  _typeLabel,
} from "../../core/core";
import { Button } from "../button/button";
import { Tag } from "../Tag/Tag";
import { Text } from "../texts/text";
import "./InputTag.css";

interface InputTagProps {
  size?: _size;
  type?: _typeInput;
  leftOutside?: React.ReactNode;
  rightOutside?: React.ReactNode;
  placeholder?: string;
  description?: string;
  error?: string;
  right?: React.ReactNode;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  value?: string;
  tags?: string[];
  split_sim?: string;
  setTags?: (tags: string[]) => void;
  onClickTag?: (tag: string) => void;
  setValue?: (value: string) => void;
  focusStart?: boolean;
  validation?: () => string;
  is_dropdown?: boolean;
  dropdown_list?: string[];
  onClickDropdown?: () => void;
  onBlurHandel?: () => void;
}

export const InputTag: React.FC<InputTagProps> = ({
  size = _size.M,
  type = _typeInput.text,
  leftOutside,
  rightOutside,
  placeholder,
  description,
  error = "",
  right,
  onKeyDown,
  value = "",
  tags = [],
  split_sim = " ",
  setTags = () => { },
  setValue = () => { },
  focusStart = false,
  validation,
  is_dropdown = false,
  onClickDropdown,
}) => {
  const [focus, setFocus] = useState<boolean>(focusStart);
  const [messageError, setMessageError] = useState<string>(error);

  const variantsClassName = (): string => {
    let classBuilder = `input-field input-field-${size}`;
    if (tags.length > 0) classBuilder += ` has-tags`;
    if (validation && messageError !== "") classBuilder += ` error`;
    return classBuilder;
  };

  useEffect(() => {
    if (value && value.includes(split_sim)) {
      const tagsValue = value
        .split(split_sim)
        .filter((tag) => tag.trim() !== "")
        .map((tag) => tag.trim());
      setTags([...tags, ...tagsValue]);
      setValue("");
    }
  }, [value]);

  useEffect(() => {
    if (error !== "") setMessageError(error);
  }, [error]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    if (validation) setMessageError(validation());
    setValue(event.target.value);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (onKeyDown) onKeyDown(e);
    if (e.key === "Backspace" && value === "") {
      const newTags = [...tags];
      newTags.pop();
      setTags(newTags);
    }
  };

  const onClickClear = (): void => {
    setValue("");
    setFocus(true);
    setTags([]);
  };

  const handleClickCloseTag = (tag: string | null): void => {
    if (tag === null) return;
    setTags(tags.filter((t) => t !== tag));
  };

  return (
    <div className="field">
      {(leftOutside || rightOutside) && (
        <div className="field-header">
          {leftOutside}
          {rightOutside}
        </div>
      )}
      <div className={variantsClassName()}>
        {description && (
          <Text size={_sizeText.xs} color={_colorText.neutral}>
            {description}
          </Text>
        )}
        <div
          className={`field-content field-tag-${tags.length > 0
            } field-focus-${focus}`}
        >
          {tags.map((tag, index) => (
            <Tag
              key={index}
              is_active={true}
              size={_size.S}
              type={_typeLabel.secondary}
              name={tag}
              is_active_desable={false}
              onClickClose={handleClickCloseTag}
            />
          ))}
          <input
            type={type}
            value={value}
            placeholder={placeholder}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            autoFocus={focus}
          />
        </div>
        {right && <div className="right-content">{right}</div>}
        {value && (
          <Button
            style={_style.clear}
            icon_right={<CloseSvg />}
            onClick={onClickClear}
          />
        )}
      </div>
      {is_dropdown && (
        <div className={`input-dropdown-${focus}`}>
          <div onMouseDown={onClickDropdown} className="input-dropdown-item">
            <div className="input-dropdown-r">
              <MagicpenSvg />
            </div>
            <div className="input-dropdown-l">
              <Text size={_sizeText.s} color={_colorText.black}>
                Создать ключевые слова для вашей карточки
              </Text>
              <Text size={_sizeText.xs} color={_colorText.neutral}>
                Слова создаются на основе вашей карточки
              </Text>
            </div>
          </div>
        </div>
      )}
      {description && (
        <Text size={_sizeText.xs} color={_colorText.neutral}>
          {description}
        </Text>
      )}
      {messageError && (
        <Text size={_sizeText.xs} color={_colorText.negative}>
          {messageError}
        </Text>
      )}
    </div>
  );
};
